<style scoped lang="less">
  @import './choose.less';

  .seach_box {
    .el-select {
      width: 125px;
      float: left;
      margin-right: 8px;
    }
  }

  .my-el-dialogs .seach_box .seach {
    width: 150px;
    float: none;
    display: inline-block;
  }
</style>
<style lang="less">
  @import './chooseScoped.less';
</style>
<template>
  <el-dialog custom-class="dialog-choose-what my-el-dialogs myChoosePerson" :visible.sync="is_show"
             :close-on-click-modal="false" :width="configWidth+'px'">
    <div class="choosePersonType">
      <a href="javascript:;">
        <span class="active">按校区</span>
      </a>
    </div>
    <div class="choose_main">
      <div class="choose_right">
        <div class="choose_list" :style="'width:' + (configWidth - 210 -leftWidth) + 'px'">
          <div class="seach_box">
            <el-select
              clearable
              filterable
              v-model="tableQuery.filter.campusId"
              @change="chooseCampus()"
              placeholder="请选择校区">
              <el-option
                v-for="item in campusList"
                :key="item.id"
                :label="item.campusName"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select
              clearable
              filterable
              v-if="vocFlag"
              v-model="tableQuery.filter.branchId"
              @change="getSpecialty()"
              placeholder="院系">
              <el-option
                v-for="item in branchIdStrs"
                :label="item.name"
                :value="item.id"
                :key="item.id"/>
            </el-select>
            <el-select
              clearable
              filterable
              v-if="vocFlag"
              v-model="tableQuery.filter.specialtyId"
              placeholder="专业">
              <el-option
                v-for="item in specialtyIdStrs"
                :label="item.specialtyName"
                :value="item.specialtyId"
                :key="item.specialtyId"/>
            </el-select>
            <el-select
              placeholder="年级"
              filterable
              clearable
              @change="handleCurrentChange(1)"
              @visible-change="getGradeList"
              v-model="tableQuery.filter.gradeId">
              <el-option
                v-for="item in gradeList"
                :label="item.gradeName"
                :value="item.id"
                :key="item.id"/>
            </el-select>
            <el-select
              placeholder="班级"
              filterable
              clearable
              @change="handleCurrentChange(1)"
              v-model="tableQuery.filter.classId">
              <el-option
                v-for="item in classList"
                :label="item.className"
                :value="item.id"
                :key="item.id"/>
            </el-select>
            <div class="seach">
              <div class="el-input el-input--small el-input el-input-group el-input-group--append">
                <input type="text" placeholder="请输入内容" autocomplete="off" @keyup.13="search"
                       v-model="tableQuery.filter.userName"
                       class="el-input__inner">
                <div class="el-input-group__append">
                  <button type="button" @click="search" class="el-button el-button--default">
                    <i class="el-icon-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div style="padding: 10px 10px 0px 10px" class="myTable">
            <el-table :data="tableData.aaData"
                      v-loading="loading"
                      border
                      element-loading-text="拼命加载中"
                      ref="multipleTable"
                      @select="handleSelectionChange"
                      @select-all="allselect"
                      :height="ht"
                      class="org_table">
              <el-table-column type="selection" width="38px">
              </el-table-column>
              <el-table-column prop="userName" label="姓名" show-overflow-tooltip width="120px">
              </el-table-column>
              <el-table-column v-for="(vv,index) in config.right.waiting.columnList" :prop="vv.displayKey"
                               :key="vv.displayKey" :label="vv.caption" show-overflow-tooltip
                               :width="index == 2?'':'160px'">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="check_info" :style="'width:'+leftWidth+'px'">
          <div class="selected-personnel">已选人员({{personList.length}})
            <i class="el-icon-delete" @click="clearAll"></i>
          </div>
          <ul class="person_list">
              <li  v-for="(pn, index) in personList" :key="pn.id">
                <a href="javascript:;" :title="pn.userName" :key="pn.id">
                  <span>{{pn.userName}}</span>
                  <i class="el-icon-close" @click="unChoose(pn,index)"></i>
                </a>
              </li>
          </ul>
        </div>
        <div class="footer">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="tableQuery.page = $event, search()"
            :total="tableData.iTotalRecords"
            :page-size="tableQuery.size"
            layout="->, total, sizes, prev, pager, next, jumper">
          </el-pagination>
          <el-button type="primary" @click="config.confirm(personList),is_show = false">确定(已选{{personList.length}}人)
          </el-button>
          <el-button @click="is_show = false">取消</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    data() {
      return {
        campusList: [],
        branchIdStrs: [],
        specialtyIdStrs: [],
        gradeList: [],
        classList: [],
        vocFlag: false,
        tableQuery: {
          page: 1,
          size: 10,
          draw: 0,
          filter: {
            roleTypeCode: "S",
            shortCode: "S",
            campusId: "",
            gradeId: "",
            classId: "",
            branchId: "",
            specialtyId: "",
            userName: ""
          }
        },
        tableData: {
          aaData: [],
          draw: 0,
          iTotalDisplayRecords: 0,
          iTotalRecords: 0
        },
        configWidth: '1080',
        leftWidth: '220',
        role: [
          {key: "T", value: "教师"},
          {key: "S", value: "学生"},
          {key: "P", value: "家长"}
        ],
        roleid: "",
        config: {
          caption: "选择控件",
          multi: true,
          confirm: function () {
          },
          left: [],
          selected: [],
          right: {
            waiting: {
              conditionList: [],
              columnList: []
            },
            selected: {
              getInfoUrl: "",
              conditionList: [],
              columnList: []
            }
          }
        },

        loading: true,
        is_show: false,
        nowLeft: {},
        noAuth: 0,
        ht: "450",
        personList: [],
        selectedData: [],
      };
    },
    created() {
      Array.prototype.unique1 = function () {
        let res = [this[0]];
        for (let i = 1; i < this.length; i++) {
          let repeat = false;
          for (let j = 0; j < res.length; j++) {
            if (this[i].id === res[j].id) {
              repeat = true;
              break;
            }
          }
          if (!repeat) {
            res.push(this[i]);
          }
        }
        return res;
      }; //去重
      this.query();
      this.search();
    },
    methods: {
      pageSizeChange(v) {//每页显示条数
        let vm = this;
        vm.tableQuery.size = v;
        vm.search();
      },
      unChoose(pn, index) {//单个删除已选择人员
        let vm = this;
        let ii = vm.personList[index];
        let n = vm.personList.length;
        for (let j = 0; j < vm.tableData.aaData.length; j++) {
          if (ii.id === vm.tableData.aaData[j].id) {
            vm.tableData.aaData[j].querySelected = false;
            vm.$nextTick(function () {
              vm.$refs.multipleTable.toggleRowSelection(vm.tableData.aaData[j], false);
            });
          }
        }
        for (let j = 0; j < n; j++) {//删除缓存结果数据
          if (vm.personList[j].id === ii.id) {
            vm.personList.splice(j, 1);
            n = n - 1;
          }
        }
        let d = vm.selectedData.length;
        for (let g = 0; g < d; g++) {
          //删除中间缓存数据
          if (vm.selectedData[g].id === pn.id) {
            vm.selectedData.splice(g, 1);
            d = d - 1;
          }
        }
      },
      clearAll() {//删除所有已选择人员
        let vm = this;
        if (vm.personList.length > 0) {
          vm.selectedData = [];
          vm.personList = [];
          vm.search();
        }
      },
      search() {
        let vm = this;
        vm.loading = true;
        let obj = $.extend({}, vm.tableQuery, {
          filter: eduFilterParam(vm.tableQuery.filter)
        });
        //查询接口更换
        http.get(InterfacePrefix['platform'] + '/student/page', {params: obj}).then(function (xhr) {
          _.each(xhr.data.aaData, function (vv) {
            vv.querySelected = false;
            vv.deSelected = false;
            vm.$set(vv, "id", vv.userId);
          });
          vm.tableData = xhr.data
          vm.$nextTick(function () {
            for (let i = 0; i < vm.personList.length; i++) {
              //回显
              for (
                let j = 0;
                j < vm.tableData.aaData.length;
                j++
              ) {
                if (
                  vm.personList[i].id === vm.tableData.aaData[j].id
                ) {
                  vm.tableData.aaData[j].querySelected = true;
                  vm.$nextTick(function () {
                    vm.$refs.multipleTable.toggleRowSelection(
                      vm.tableData.aaData[j],
                      true
                    );
                  });
                }
              }
            }
          });
          setTimeout(() => {
            vm.loading = false;
          }, 500);
        })
      },
      allselect(val) {//全选
        let vm = this;
        let el = true;
        if (val.length > 0) {
          _.each(vm.tableData.aaData, function (vv) {
            vv.querySelected = true;
            vm.handleSelectionChange(el, vv, 1);
          });
        } else {
          _.each(vm.tableData.aaData, function (vv) {
            vv.querySelected = false;
            vm.handleSelectionChange(el, vv, 2);
          });
        }
      },
      handleSelectionChange(e, v, s) {//选择人员
        let vm = this;
        let checked = e === true ? e : !v.querySelected;
        if (s) {
          s === 1 ? (checked = true) : (checked = false);
        }
        if (checked) {
          //是否勾选
          for (let j = 0; j < vm.tableData.aaData.length; j++) {
            if (v.id === vm.tableData.aaData[j].id) {
              vm.tableData.aaData[j].querySelected = true;
              vm.$nextTick(function () {
                vm.$refs.multipleTable.toggleRowSelection(
                  vm.tableData.aaData[j],
                  true
                );
              });
            }
          }
        }
        let list = _.filter(vm.tableData.aaData, function (vv) {
          return vv.querySelected;
        });
        if (checked) {
          //是否勾选
          let b = [];
          if (list.length !== 0) {
            let aa = list.length;
            for (let j = 0; j < aa; j++) {
              //合并数据
              vm.selectedData.push(list[j]);
            }
          }
          b = vm.selectedData;
          if (vm.selectedData.length > 1) {
            vm.selectedData = b.unique1();
          } else {
            vm.selectedData = b;
          }
        } else {
          for (let j = 0; j < vm.tableData.aaData.length; j++) {
            if (v.id === vm.tableData.aaData[j].id) {
              vm.tableData.aaData[j].querySelected = false;
              vm.$nextTick(function () {
                vm.$refs.multipleTable.toggleRowSelection(
                  vm.tableData.aaData[j],
                  false
                );
              });
            }
          }
          let s = vm.selectedData.length;
          for (let h = 0; h < s; h++) {
            //删除中间缓存数据
            if (vm.selectedData[h].id === v.id) {
              vm.selectedData.splice(h, 1);
              s = s - 1;
              h = h - 1;
            }
          }
        }
        if (vm.selectedData.length > 1) {
          vm.personList = vm.selectedData.unique1();
        } else {
          vm.personList = vm.selectedData;
        }
      },
      query() {
        let vm = this;
        let SelectPeopleParam = {
          noAuth: vm.noAuth
        };
        vm.getCampus();
        vm.search();
        //查询学校
      },
      getCampus() {
        const vm = this;
        http.get(InterfacePrefix['platform'] + "/campus/list", {params: {status: "1"}}).then(function (xhr) {
          vm.campusList = xhr.data.data;
        })
      },
      getBranch() {
        let vm = this;
        Promise.all([
          http.get(window.InterfacePrefix.platform + '/branch')
        ]).then(function (list) {
          vm.branchIdStrs = _.filter(list[0].data, function (i) {
            return i.id;
          });
        });
      },
      getSpecialty() {
        let vm = this;
        let id = vm.tableQuery.filter.branchId;
        if (id) {
          Promise.all([
            http.get(window.InterfacePrefix.platform + '/branchSpecialty/' + id)
          ]).then(function (list) {
            vm.specialtyIdStrs = _.filter(list[0].data.data, function (i) {
              return i.id;
            });
          });
        }
      },
      getGradeList(show) {
        let vm = this;
        if (show) {
          if (!vm.tableQuery.filter.campusId) {
            vm.$message.warning("请选择校区！");
            return;
          }
          http.get(`${window.InterfacePrefix.platform}/grade/param?campusId=${vm.tableQuery.filter.campusId}`)
            .then(function (xhr) {
              if (xhr.data.code) return;
              vm.gradeList = xhr.data.data;
            });
        }
      },
      getClassList(id) {
        let vm = this;
        vm.$set(vm.tableQuery.filter, "classId", "");
        if (!id) {
          vm.classList.splice(0, vm.classList.length);
          return;
        }
        let obj = {
          campusId: id
        };
        http.get(window.InterfacePrefix.platform + "/class/param", {params: obj}).then(
          function (xhr) {
            if (xhr.data.code) {
              return;
            }
            vm.classList = xhr.data.data;
          }
        );
      },
      handleCurrentChange(val) {
        let vm = this;
        vm.tableQuery.page = val;
        if (vm.tableQuery.filter.gradeId) {
          http.get(window.InterfacePrefix.platform + "/class/courseInfo/" + vm.tableQuery.filter.gradeId, {
            params: {
              campusId: vm.tableQuery.filter.campusId
            }
          }).then(function (xhr) {
            if (xhr.data.code) {
              return;
            }
            vm.classList = xhr.data.data;
          });
        } else {
          vm.getClassList(vm.tableQuery.filter.campusId);
        }
        vm.search();
      },
      chooseCampus() {
        let vm = this;
        vm.tableQuery.filter.gradeId = "";
        if (vm.tableQuery.filter.campusId) {
          http.get(window.InterfacePrefix.platform + "/campus/" + vm.tableQuery.filter.campusId)
            .then(function (xhr) {
              if (!xhr.data.code) {
                let orgId = xhr.data.data.orgId
                http.post(window.InterfacePrefix.platform + "/api/configuration/listByKeys/" + orgId, ["voc_evn"]).then(function (xhr) {
                  if (xhr.data && xhr.data.length) {
                    vm.vocFlag = true;
                    vm.getBranch();
                  } else {
                    vm.vocFlag = false;
                  }
                  vm.getClassList(vm.tableQuery.filter.campusId);
                  vm.search();
                })
              }
            });
        }else {
          vm.vocFlag = false;
          vm.search();
        }
      }
    },
    watch: {
      nowLeft(val) {
        let vm = this;
        vm.query();//初始加载方法
      },
      config(val) {
        console.log("config", val)
        let vm = this;

        //回选
        vm.personList = [];
        _.each(val.seletedData, function (vv) {
          vv.querySelected = true;
        });
        vm.noAuth = val.noAuth;
        vm.personList = val.seletedData;
        vm.selectedData = val.seletedData;

        if (val.width) {
          vm.configWidth = val.width
        }
        if (val.leftWidth) {
          vm.leftWidth = val.leftWidth
        }

        //角色
        vm.role = val.role;
        if (val.role.length === 1) {
          vm.roleid = val.role[0].key;
        } else {
          vm.roleid = "";
        }

        //是否清空筛选条件
        vm.isEmptyFilter = val.isEmptyFilter
        this.nowLeft = val.left[0];
      },
      is_show(val) {
        let vm = this;
        if (val) {
          this.tableQuery = {
            page: 1,
            size: 10,
            draw: 0,
            filter: {
              campusId: "",
              gradeId: "",
              classId: "",
              branchId: "",
              specialtyId: "",
              userName: ""
            }
          }
          this.tableData = {
            aaData: [],
            draw: 0,
            iTotalDisplayRecords: 0,
            iTotalRecords: 0
          }
        } else {
          if (vm.isEmptyFilter) {//是否清空筛选条件
            vm.tableQuery = {
              page: 1,
              size: 10,
              draw: 0,
              filter: {
                campusId: "",
                gradeId: "",
                classId: "",
                branchId: "",
                specialtyId: "",
                userName: ""
              }
            }
          }
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/commonplugin/choose/chooseMajor.vue